import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {DataService} from './data.service';


@Injectable({
    providedIn: 'root'
})
export class DataResolverService implements Resolve<any> {
    constructor(
        private dataService: DataService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        const {sid} = route.params;
        return this.dataService.getSession(sid);
    }
}
